import { createGlobalStyle } from 'styled-components'
import Exo2 from '../fonts/Exo2-Regular.woff2'

const GlobalStyles = createGlobalStyle`
  @font-face {
    font-family: "${({ theme }) => theme.font}";
    src: url('${Exo2}') format('woff2');
  }

  * {
    /* outline: 1px solid red; // debugging tool to highlight elements */
  }

  body {
    margin: 0;
    overflow: auto;
    font-family: "${({ theme }) => theme.font}", sans-serif;
    font-size: 16px;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  #root {
    display: grid;
    grid-template-areas:
      'header'
      'content';
    /* grid-template-columns: 1fr 4fr 1fr; */
    /* grid-template-rows: 100px 1fr; */
    grid-template-rows: ${({ theme }) => theme.sizes.heights.header} 1fr;
  }
`

export default GlobalStyles
